import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALES,
  GET_SALES_ONE,
  DELETE_SALES,
  UPDATE_SALES,
  ADD_NEW_SALES,
} from "./actionType";

import {
  getSalesSuccess,
  getSalesFail,
  deleteSalesSuccess,
  deleteSalesFail,
  updateSalesSuccess,
  updateSalesFail,
  addSalesSuccess,
  addSalesFail,
  getSalesLoading,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesApi,
  getSalesApi,
  updateSalesApi,
  deleteSalesApi,
  addNewSalesApi,
  getOneSalesApi
} from "../../helpers/backend_helper";

function* getSales({ payload: sales }) {
  try {
    const response = yield call(getSalesApi, sales);
    yield put(getSalesSuccess(GET_SALES, response.data));
  } catch (error) {
    yield put(getSalesFail(GET_SALES, error));
  }
}

function* getSalesOne({ payload: id }) {
  try {
    const response = yield call(getOneSalesApi, id);
    yield put(getSalesSuccess(GET_SALES_ONE, response));
  } catch (error) {
    yield put(getSalesFail(GET_SALES_ONE, error));
  }
}

function* onUpdateSales({ payload: sales }) {
  try {
    yield put(getSalesLoading());
    if (sales.setApprove) {
      const response = yield call(approveSalesApi, sales);
      yield put(updateSalesSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesApi, sales);
      yield put(updateSalesSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSales({ payload: sales }) {
  try {
    yield put(getSalesLoading());
    const response = yield call(deleteSalesApi, sales);
    yield put(deleteSalesSuccess({ sales, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSales({ payload: sales }) {
  try {
    yield put(getSalesLoading());
    const response = yield call(addNewSalesApi, sales);
    yield put(addSalesSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSales() {
  yield takeEvery(GET_SALES, getSales);
}

export function* watchGetSalesOne() {
  yield takeEvery(GET_SALES_ONE, getSalesOne);
}

export function* watchUpdateSales() {
  yield takeEvery(UPDATE_SALES, onUpdateSales);
}

export function* watchDeleteSales() {
  yield takeEvery(DELETE_SALES, onDeleteSales);
}

export function* watchAddNewSales() {
  yield takeEvery(ADD_NEW_SALES, onAddNewSales);
}

function* salesSaga() {
  yield all([
    fork(watchGetSales),
    fork(watchGetSalesOne),
    fork(watchDeleteSales),
    fork(watchUpdateSales),
    fork(watchAddNewSales)
  ]);
}

export default salesSaga;
